import React from "react";
import { useNavigate } from "react-router-dom";
import { useBrand } from "../../context/BrandContext";
import { apiUrl } from "../../config/config";

const Hero = () => {
  const navigate = useNavigate();
  const { brandData, loading } = useBrand();

  const bannerImage = brandData?.settings?.banner?.image
    ? `${apiUrl}/storage/${brandData.settings.banner.image}`
    : "";

  return (
    <section className="relative w-full overflow-hidden bg-[#1e242a]">
      {loading ? (
        <div className="relative min-h-[520px] md:min-h-[620px] flex items-center justify-center px-4 bg-[#1e242a]">
          <div className="w-full max-w-5xl animate-pulse text-center space-y-6">
            <div className="h-12 md:h-16 bg-white/20 rounded-xl w-4/5 mx-auto"></div>
            <div className="h-5 md:h-6 bg-white/15 rounded-lg w-3/5 mx-auto"></div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
              <div className="h-14 w-52 bg-white/20 rounded-lg"></div>
              <div className="h-14 w-52 bg-white/20 rounded-lg"></div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="relative min-h-[520px] sm:min-h-[580px] lg:min-h-[660px] bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: bannerImage ? `url(${bannerImage})` : "none",
          }}
        >
          {/* PROFESSIONAL DARK THEME OVERLAY */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#1e242a]/95 via-[#37404a]/80 to-[#5f6870]/60"></div>
          <div className="absolute inset-0 bg-black/25"></div>

          {/* CONTENT */}
          <div className="relative z-10 min-h-[520px] sm:min-h-[580px] lg:min-h-[660px] flex items-center">
            <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-5xl mx-auto text-center">
                

                <h1 className="mt-6 text-white font-extrabold leading-[1.05] tracking-tight text-[38px] sm:text-5xl md:text-6xl lg:text-7xl xl:text-[82px] drop-shadow-lg">
                  {brandData?.settings?.banner?.header_heading || ""}
                </h1>

                <p className="mt-6 text-white/90 text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed max-w-4xl mx-auto drop-shadow-md">
                  {brandData?.settings?.banner?.paragraph || ""}
                </p>

                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                  <button
                    className="w-full sm:w-auto min-w-[220px] rounded-lg bg-[#e5e8e6] px-8 py-4 text-base font-bold text-[#1e242a] shadow-xl transition-all duration-300 hover:-translate-y-0.5 hover:bg-white"
                    onClick={() => navigate("/products")}
                  >
                    Customize Patches
                  </button>

                  <button
                    className="w-full sm:w-auto min-w-[220px] rounded-lg border border-white/25 bg-[#1e242a]/90 px-8 py-4 text-base font-bold text-white shadow-xl backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#2f3740]"
                    onClick={() => navigate("/products")}
                  >
                    Explore Products
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;